import { render, staticRenderFns } from "./SalesPersonDropdownField.vue?vue&type=template&id=3ba1cffe"
import script from "./SalesPersonDropdownField.vue?vue&type=script&lang=ts"
export * from "./SalesPersonDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba1cffe')) {
      api.createRecord('3ba1cffe', component.options)
    } else {
      api.reload('3ba1cffe', component.options)
    }
    module.hot.accept("./SalesPersonDropdownField.vue?vue&type=template&id=3ba1cffe", function () {
      api.rerender('3ba1cffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/SalesPersonDropdownField.vue"
export default component.exports